import React from 'react';
import { computeAsRepairAutoValueFromConfig, formatAsRepairAutoDisplay } from '../utils/asRepairFormConfig';

const AsRepairAutoCalculatedField = ({
    id,
    label,
    required = false,
    field,
    formConfig,
    values,
    inputRef,
}) => {
    let computed = '';
    try {
        computed = computeAsRepairAutoValueFromConfig(formConfig, field, values);
    } catch (error) {
        computed = '';
    }
    const display = formatAsRepairAutoDisplay(computed);
    const hasFormula = String(field?.formula || '').trim().length > 0;

    return (
        <div className="as-repair-add-field">
            <label className="field-label" htmlFor={id}>
                {label}
                {required ? <span className="as-repair-required-mark"> *</span> : null}
            </label>
            <input
                id={id}
                ref={inputRef}
                type="text"
                className="field-input as-repair-auto-calc-input"
                value={display === '-' ? '' : display}
                readOnly
                tabIndex={-1}
                placeholder={hasFormula ? '자동 계산' : '계산식 설정 후 자동 표시'}
                aria-readonly="true"
                title={hasFormula ? '자동 계산 항목 (직접 수정 불가)' : '제품등록 설정에서 계산식을 입력하면 자동으로 표시됩니다'}
            />
        </div>
    );
};

export default AsRepairAutoCalculatedField;
